import { defaultConfig, defineSemanticTokens } from '@chakra-ui/react';

const semanticColors = defineSemanticTokens.colors({
    ...defaultConfig.theme?.semanticTokens?.colors,
    bg: {
        DEFAULT: { value: { _light: '{colors.light}', _dark: '{colors.dark}' } },

        subtle: { value: { _light: '{colors.gray.50}', _dark: '{colors.gray.900}' } },
        muted: { value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' } },
        emphasized: { value: { _light: '{colors.gray.300}', _dark: '{colors.gray.700}' } },
        inverted: { value: { _light: '{colors.dark}', _dark: '{colors.light}' } },

        panel: { value: { _light: '{colors.light}', _dark: '{colors.gray.900}' } },

        brand: { value: { _light: '{colors.indigo.200}', _dark: '{colors.indigo.900}' } },
        danger: { value: { _light: '{colors.red.100}', _dark: '{colors.red.900}' } },
        error: { value: { _light: '{colors.red.100}', _dark: '{colors.red.900}' } },
        success: { value: { _light: '{colors.green.100}', _dark: '{colors.green.900}' } },
        warning: { value: { _light: '{colors.yellow.100}', _dark: '{colors.yellow.900}' } },
        info: { value: { _light: '{colors.blue.100}', _dark: '{colors.blue.900}' } },
    },
    border: {
        DEFAULT: { value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' } },
        subtle: { value: { _light: '{colors.gray.100}', _dark: '{colors.gray.800}' } },
        muted: { value: { _light: '{colors.gray.300}', _dark: '{colors.gray.700}' } },
        emphasized: { value: { _light: '{colors.gray.300}', _dark: '{colors.gray.500}' } },
        inverted: { value: { _light: '{colors.gray.700}', _dark: '{colors.gray.200}' } },

        panel: { value: { _light: '{colors.gray.200}', _dark: '{colors.gray.800}' } },

        danger: { value: { _light: '{colors.red.500}', _dark: '{colors.red.400}' } },
        error: { value: { _light: '{colors.red.500}', _dark: '{colors.red.400}' } },
        success: { value: { _light: '{colors.green.600}', _dark: '{colors.green.500}' } },
        warning: { value: { _light: '{colors.yellow.600}', _dark: '{colors.yellow.200}' } },
        info: { value: { _light: '{colors.blue.600}', _dark: '{colors.blue.500}' } },
    },
    fg: {
        DEFAULT: { value: { _light: '{colors.dark}', _dark: '{colors.light}' } },
        muted: { value: { _light: '{colors.gray.700}', _dark: '{colors.gray.300}' } },
        subtle: { value: { _light: '{colors.gray.500}', _dark: '{colors.gray.400}' } },
        inverted: { value: { _light: '{colors.light}', _dark: '{colors.dark}' } },
        danger: { value: { _light: '{colors.red.500}', _dark: '{colors.red.400}' } },
        error: { value: { _light: '{colors.red.500}', _dark: '{colors.red.400}' } },
        success: { value: { _light: '{colors.green.600}', _dark: '{colors.green.300}' } },
        warning: { value: { _light: '{colors.yellow.600}', _dark: '{colors.yellow.300}' } },
        info: { value: { _light: '{colors.blue.600}', _dark: '{colors.blue.300}' } },
        brand: { value: { _light: '{colors.indigo.500}', _dark: '{colors.indigo.500}' } },
    },
    brand: {
        contrast: {
            value: { _light: '{colors.light}', _dark: '{colors.light}' },
        },
        fg: {
            value: { _light: '{colors.indigo.700}', _dark: '{colors.indigo.200}' },
        },
        subtle: {
            value: { _light: '{colors.indigo.100}', _dark: '{colors.indigo.900}' },
        },
        muted: {
            value: { _light: '{colors.indigo.200}', _dark: '{colors.indigo.800}' },
        },
        emphasized: {
            value: { _light: '{colors.indigo.300}', _dark: '{colors.indigo.700}' },
        },
        solid: {
            value: { _light: '{colors.indigo.600}', _dark: '{colors.indigo.600}' },
        },
        focusRing: {
            value: { _light: '{colors.indigo.500}', _dark: '{colors.indigo.500}' },
        },
    },
});

export { semanticColors };
